import React, { useState, useEffect, useRef } from 'react';
import './Services.css';
import ProductOrService from './components/ProductOrService/ProductOrService';
import ServiceFilter from './components/ServiceFilter/ServiceFilter';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const Services = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('Services - Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('Services activeData:', activeData);
  console.log('Services scenarioPrefix:', scenarioPrefix);

  // State for toggles - matching Dashboard pattern
  const [toggles, setToggles] = useState({
    serviceFilter: true,
    productOrService: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Template name logic with scenario prefix - matching Dashboard pattern
  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-services' 
    : `gardenwall-services-${scenarioPrefix}`;
    
  console.log('Services Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching Dashboard
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching Dashboard pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates]);

  // Fetch templates function - matching Dashboard
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching Dashboard
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching Dashboard
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching Dashboard
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('Services Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles || {
            serviceFilter: true,
            productOrService: true,
          });
          setBlockStates(template_data.blockStates || {});
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('Services specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching Dashboard pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        scenarioData: paymentScenario
      })
    );
    
    console.log('Services - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('Services Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving services template:', error);
    }
  };

  return (
    <div className="subscriberConnect-container">
      {/* Services Header with Payment Scenario Status */}
      <h1 className="services-header">
        Services – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
      </h1>

      <div className="services-grid">
        {/* Service Filter Card */}
        <div className={`card col-4 service-filter ${!toggles.serviceFilter ? 'card-disabled' : ''}`}>
          <div className="card-header">
            Service Filter
            <div className="custom-toggle" onClick={() => handleToggle('serviceFilter')}>
              <input type="checkbox" checked={toggles.serviceFilter} readOnly />
              <span className="toggle-slider"></span>
            </div>
          </div>
          <ServiceFilter 
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          />
        </div>

        {/* Product or Service Card */}
        <div className={`card col-4 product-or-service ${!toggles.productOrService ? 'card-disabled' : ''}`}>
          <div className="card-header">
            Product or Service
            <div className="custom-toggle" onClick={() => handleToggle('productOrService')}>
              <input type="checkbox" checked={toggles.productOrService} readOnly />
              <span className="toggle-slider"></span>
            </div>
          </div>
          <ProductOrService 
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          />
        </div>
      </div>
    </div>
  );
};

export default Services;

